import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loginType: 1,      // 登录类型：1-二维码登录；2-管理员登录
  },
  mutations: {
    setLoginType(state, value) {
      state.loginType = value
    }
  },
  getters: {
    getLoginType: (state) => state.loginType
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js